import './Board.scss';
import Grid from "../Grid/Grid";
import {GameEngine} from "../../engine/GameEngine";
import React, {forwardRef, useImperativeHandle, useState} from "react";

interface BoardProps {
    id: number;
    player: string;
    onClick: (row: number, col: number) => void;
}

const gameEngine = new GameEngine();

const Board = forwardRef((props: BoardProps, ref) => {
    const [game, setGame] = useState(gameEngine.initial(props.id, props.player));

    const update = (row: number, col: number) => {
        const newGame = gameEngine.update(game, row, col);
        setGame(newGame);
    };
    
    const reset = () => {
        const newGame = gameEngine.initial(props.id, props.player);
        setGame(newGame);
    };
    
    useImperativeHandle(ref, () => ({
        update,
        reset,
    }));

    const simpleSvgLine = (x1: number, y1: number, x2: number, y2: number) => {
        return <svg className='Cross' viewBox='0 0 6 6' preserveAspectRatio='none'>
            <line stroke='currentColor'
                  x1={x1}
                  y1={y1}
                  x2={x2}
                  y2={y2}
            />
        </svg>;
    }

    const onGridClick = (row: number, col: number) => {
        if (!gameEngine.canPlay(game)) {
            return;
        }

        props.onClick(row, col);
    }

    let line = null
    if (game.won) {
        if (game.horizontal > -1) {
            line = simpleSvgLine(0, game.horizontal * 2 + 1, 6, game.horizontal * 2 + 1);
        } else if (game.vertical > -1) {
            line = simpleSvgLine(game.vertical * 2 + 1, 0, game.vertical * 2 + 1, 6);
        } else if (game.cross === 0) {
            line = simpleSvgLine(0, 0, 6, 6);
        } else if (game.cross === 1) {
            line = simpleSvgLine(6, 0, 0, 6);
        }
    }

    return (
        <div className="Board" data-testid="Board">
            <Grid values={game.values} onClick={onGridClick}/>
            {line}
            {game.finished?<div className="Reset" onClick={reset}></div>:""}
        </div>
    );
});

export default Board;
